<template>
  <q-page id="metas">
    <div class="q-pa-md">
      <sem-permissao v-if="semPermissao"></sem-permissao>
      <q-card v-else>
        <q-card-section>
          <div class="q-mt-md text-center" v-show="loading">
            <q-spinner color="blue-7" size="3em" />
          </div>

          <div v-if="!loading" class="row items-center">
            <q-btn flat round dense icon="add" id="addMetas" class="q-ml-md text-primary"
              style="margin-right: 10px;margin-left: 0" @click="openDialogMeta = true" />
            <div class="col-2 q-table__title">Metas</div>

            <q-space />

            <!-- Filtro de datas -->
            <q-btn-group rounded flat no-wrap no-caps class="q-ml-sm">
              <q-btn dense class="white text-blue-7" clickable @click="changeFilterPeriodo('prev')" rounded
                icon="chevron_left" />
              <q-btn dense class="white text-blue-7" rounded :label="dtini">
                <template v-slot:default>
                  <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                    <q-date mask="DD/MM/YYYY" :locale="langDate" minimal today-btn v-model="dtini"
                      @update:model-value="(value) => enviaData1(value)" />
                  </q-popup-proxy>
                </template>
              </q-btn>
              <q-btn dense class="white text-blue-7" rounded :label="dtfim">
                <template v-slot:default>
                  <q-popup-proxy ref="qDateProxy2" transition-show="scale" transition-hide="scale">
                    <q-date mask="DD/MM/YYYY" :locale="langDate" minimal today-btn v-model="dtfim"
                      @update:model-value="(value) => enviaData2(value)" />
                  </q-popup-proxy>
                </template>
              </q-btn>
              <q-btn dense class="white text-blue-7" clickable @click="changeFilterPeriodo('next')" rounded
                icon="chevron_right" />
            </q-btn-group>
            <!-- Filtro de datas -->

            <q-btn v-if="$q.screen.gt.xs && !loading" flat dense no-wrap v-ripple color="primary" no-caps
              :label="statusFilter" @click="toggleStatus" class="q-ml-sm q-px-md bg-white text-blue-7"
              style="margin-right: 10px" />
          </div>

          <div v-if="!loading && metas.length === 0" class="col justify-center">
            <div class="text-center">
              <q-icon @click="openDialogMeta = true" name="info_outline" size="100px" color="grey" />

              <div class="text">Nenhuma meta definida!</div>
              <div class="text">Configure a primeira meta clicando no icone acima!</div>
            </div>
          </div>

          <div v-if="!loading && metas.length > 0" class="row q-py-md">
            <div v-for="meta in metas" :key="meta.id" class="col-12 col-md-6 col-lg-4 q-pa-sm">
              <q-card class="full-height">
                <q-card-section class="row items-center q-pb-none">
                  <div class="text-subtitle1" :title="meta.titulo">
                    {{ meta.titulo.length > 30 ? meta.titulo.slice(0, 30) + '...' : meta.titulo }}
                  </div>

                  <q-space />

                  <q-toggle v-model="meta.showOperadores" color="primary" label="Ver por operador" left-label />

                  <q-btn dense flat icon="more_vert" class="bg-grey-2 text-grey-8">
                    <q-menu>
                      <q-list>
                        <q-item clickable v-close-popup>
                          <q-item-section @click="duplicateMeta(meta)">
                            <q-item-label class="row items-center">
                              <q-icon name="content_copy" size="18px" class="q-mr-sm" />
                              Duplicar
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                        <q-item clickable v-close-popup>
                          <q-item-section @click="editMeta(meta)">
                            <q-item-label class="row items-center">
                              <q-icon name="edit" size="18px" class="q-mr-sm" />
                              Editar
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                        <q-item clickable v-close-popup>
                          <q-item-section @click="deleteMeta(meta)">
                            <q-item-label class="row items-center">
                              <q-icon name="delete" size="18px" class="q-mr-sm" />
                              Excluir
                            </q-item-label>
                          </q-item-section>
                        </q-item>
                      </q-list>
                    </q-menu>
                  </q-btn>
                </q-card-section>

                  <q-card-section class="q-pa-none">
                    <!-- Gráfico -->
                    <RadialBarChart v-if="!meta.showOperadores" :series="getChartSeries(meta)"
                      :options="getChartOptions(meta)" :height="340" />

                    <MixedChart v-else :series="getOperadoresSeries(meta)" :options="getOperadoresChartOptions(meta)"
                      :height="340" />
                  </q-card-section>

                  <!-- Tabela com Operadores -->
                  <q-markup-table dense class="no-shadow">
                    <thead>
                      <tr>
                        <th class="text-left">Operador</th>
                        <th class="text-right">Meta</th>
                        <th class="text-right">Realizado</th>
                        <th class="text-right">Diferença</th>
                      </tr>
                    </thead>

                    <tbody v-if="meta.operadores_metas.length">
                      <tr v-for="(operadorMeta, operadorId) in meta.por_operador" :key="operadorId">
                        <td>
                          <div class="ellipsis" style="max-width: 200px; overflow: hidden; white-space: nowrap;">
                            {{
                              operadorMeta.nome.length > 20
                                ? operadorMeta.nome.slice(0, 20) + '...'
                                : operadorMeta.nome
                            }}
                            <q-tooltip anchor="bottom middle" self="top middle">
                              {{ operadorMeta.nome }}
                            </q-tooltip>
                          </div>
                        </td>
                        <td class="text-right">
                          {{ meta.tipo === 'valor' ? 'R$' : '' }}
                          {{ formatarValorMetaOperador(operadorMeta.meta_individual, meta.tipo) }}
                        </td>
                        <td class="text-right">
                          {{ `(${operadorMeta.percentual_alcancado}%)` }}
                          {{ meta.tipo === 'valor' ? 'R$' : '' }}
                          {{ formatarValorMetaOperador(operadorMeta.total_realizado, meta.tipo) }}
                        </td>
                        <td class="text-right">
                          {{ meta.tipo === 'valor' ? 'R$' : '' }}
                          {{ formatarValorMetaOperador((operadorMeta.total_realizado - operadorMeta.meta_individual),
                            meta.tipo) }}
                        </td>
                      </tr>

                      <tr class="bg-grey-2 text-weight-bold">
                        <td>Totais</td>
                        <td class="text-right">
                          {{ meta.tipo === 'valor' ? 'R$' : '' }}
                          {{
                            formatarValorMetaOperador(
                              Object.values(meta.por_operador).reduce((acc, op) => acc + Number(op.meta_individual), 0),
                              meta.tipo
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            '(' +
                            (
                              Object.values(meta.por_operador).reduce((acc, op) => acc + Number(op.total_realizado), 0) /
                              Object.values(meta.por_operador).reduce((acc, op) => acc + Number(op.meta_individual), 0) *
                              100
                            ).toFixed(2) + '%)'
                          }}
                          {{ meta.tipo === 'valor' ? 'R$' : '' }}
                          {{
                            formatarValorMetaOperador(
                              Object.values(meta.por_operador).reduce((acc, op) => acc + Number(op.total_realizado), 0),
                              meta.tipo
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{ meta.tipo === 'valor' ? 'R$' : '' }}
                          {{
                            formatarValorMetaOperador(
                              (
                                Object.values(meta.por_operador).reduce((acc, op) => acc + Number(op.total_realizado), 0) -
                                Object.values(meta.por_operador).reduce((acc, op) => acc + Number(op.meta_individual), 0)
                              ),
                              meta.tipo
                            )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </q-markup-table>

              </q-card>
            </div>
          </div>

          <q-dialog v-model="openDialogMeta" persistent>
            <q-card style="min-width: 1000px">
              <q-card-section class="row items-center">
                <div class="text-h6">
                  {{ isNewMeta ? "Nova Meta" : "Editar Meta" }}
                  <q-toggle v-model="newMeta.status" color="positive" class="right" label="Ativo" false-value="Inativo"
                    true-value="Ativo" />
                </div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup @click="closeModal()" />
              </q-card-section>
              <q-separator />
              <q-card-section>
                <div class="q-pa-md">

                  <div class="row q-col-gutter-sm">
                    <div class="col-6">
                      <div class="row  q-col-gutter-sm">
                        <div class="col-12">
                          <q-input dense v-model="newMeta.titulo" label="Título" :clearable="!$q.screen.gt.xs"
                            clear-icon="close" lazy-rules bottom-slots :error="errors.titulo ? true : false">
                            <template v-slot:error>
                              <span v-for="(error, i) in errors.titulo" :key="error + i">{{ error }}</span>
                            </template>
                          </q-input>
                        </div>

                        <div class="col-12 col-md-6">
                          <q-input dense clearable bottom-slots label="Data de Início"
                            :error="errors.data_inicio ? true : false" v-model="newMeta.data_inicio"
                            @click="$refs.qDateInicio.show()">
                            <template v-slot:append>
                              <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy ref="qDateInicio" transition-show="scale" transition-hide="scale">
                                  <q-date v-model="newMeta.data_inicio" mask="DD/MM/YYYY" :locale="langDate" minimal
                                    today-btn :options="date => isTodayOrFuture(date)"
                                    @update:model-value="pulaProx('data_inicio')" />
                                </q-popup-proxy>
                              </q-icon>
                            </template>

                            <template v-slot:error>
                              <span v-for="(error, i) in errors.data_inicio" :key="error + i">{{ error }}</span>
                            </template>
                          </q-input>
                        </div>

                        <div class="col-12 col-md-6">
                          <q-input dense clearable bottom-slots label="Data de Fim"
                            :error="errors.data_fim ? true : false" v-model="newMeta.data_fim"
                            @click="$refs.qDateFim.show()">
                            <template v-slot:append>
                              <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy ref="qDateFim" transition-show="scale" transition-hide="scale">
                                  <q-date v-model="newMeta.data_fim" mask="DD/MM/YYYY" :locale="langDate" minimal
                                    today-btn @update:model-value="pulaProx('data_fim')" />
                                </q-popup-proxy>
                              </q-icon>
                            </template>
                            <template v-slot:error>
                              <span v-for="(error, i) in errors.data_fim" :key="error + i">{{ error }}</span>
                            </template>
                          </q-input>
                        </div>

                        <div class="col-md-12">
                          <q-select dense bottom-slots v-model="selectedOperadores" :options="operadores"
                            option-value="id" option-label="nome" label="Operadores" map-options multiple use-chips
                            :error="errors.operadores_metas ? true : false">
                            <template v-slot:after>
                              <q-btn @click="adicionarTodosOperadores()" round dense flat icon="add">
                                <q-tooltip anchor="bottom middle">
                                  Incluir todos os operadores
                                </q-tooltip>
                              </q-btn>
                            </template>

                            <template v-slot:error>
                              <span v-for="(error, i) in errors.operadores_metas" :key="error + i">
                                {{ error }}
                              </span>
                            </template>
                          </q-select>
                        </div>


                        <div class="col-md-12">
                          <q-select dense v-model="produtosQtServicosFilter" :options="produtosList" emit-value
                            map-options multiple options-html display-value-html label="Produtos, Loterias e Serviços">
                            <template v-slot:append>
                              <q-icon v-if="produtosQtServicosFilter !== null" class="cursor-pointer" name="cancel"
                                @click.stop="produtosQtServicosFilter = null" />
                            </template>
                          </q-select>
                        </div>

                        <div class="col-md-12">
                          <q-select dense v-model="tagsQtServicosFilter" :options="produtosTagsList" emit-value
                            map-options multiple use-chips label="Filtrar Produtos por Tags">
                            <template v-slot:append>
                              <q-icon v-if="tagsQtServicosFilter !== null" class="cursor-pointer" name="cancel"
                                @click.stop="tagsQtServicosFilter = null" />
                            </template>
                          </q-select>
                        </div>

                      </div>
                    </div>
                    <div class="col-6">
                      <div class="row  q-col-gutter-sm">

                        <div class="col-12">
                          <q-select dense v-model="newMeta.tipo" :options="tipoOptions" option-label="label"
                            option-value="value" label="Tipo" emit-value map-options lazy-rules bottom-slots
                            :error="errors.tipo ? true : false">
                            <template v-slot:error>
                              <span v-for="(error, i) in errors.tipo" :key="error + i">{{ error }}</span>
                            </template>
                          </q-select>
                        </div>

                        <div v-if="selectedOperadores.length > 0 && newMeta.tipo !== null" class="col-12">

                          <q-expansion-item expand-separator default-opened dense>
                            <template v-slot:header>
                              <div class="row items-center full-width">
                                <div class="text-weight-bold">Meta por Operador</div>
                              </div>
                            </template>
                            <q-markup-table dense class="no-shadow q-pa-none q-ma-none">
                              <thead>
                                <tr>
                                  <th class="text-left">Operador</th>
                                  <th v-if="newMeta.tipo === 'quantidade'" class="text-right small-column">Quantidade
                                  </th>
                                  <th v-if="newMeta.tipo === 'valor'" class="text-right small-column">R$</th>
                                </tr>
                              </thead>
                              <tbody v-if="selectedOperadores.length">
                                <tr v-for="operador in selectedOperadores" :key="operador.id">
                                  <td>{{ operador.nome }}</td>
                                  <td v-if="newMeta.tipo === 'quantidade'" class="text-right small-column">
                                    <q-input :model-value="operador.valor"
 @update:model-value="operador.valor = $numero($event)" type="text" dense input-class="text-right"
                                      required />
                                  </td>
                                  <td v-if="newMeta.tipo === 'valor'" class="text-right small-column">
                                    <q-field name="valor" v-model="operador.valor" dense required id="valor">
                                      <template v-slot:control="{ id, modelValue, emitValue }">
                                        <money-input :id="id" class="q-field__native text-right" :value="modelValue"
                                          @input="emitValue" v-bind="moneyFormat" ref="valor" />
                                      </template>
                                    </q-field>
                                  </td>
                                </tr>
                              </tbody>
                            </q-markup-table>
                          </q-expansion-item>

                          <div v-if="newMeta.tipo === 'quantidade'"
                            class="row items-center justify-end q-mt-md q-pr-md">
                            <div class="q-mr-sm text-bold">Total:</div>
                            <q-input :model-value="newMeta.valor"
 @update:model-value="newMeta.valor = $numero($event)" type="text" dense input-class="text-right"
                              class="text-right" style="width: 130px">
                              <template v-slot:append>
                                <q-btn flat round icon="call_split" @click="dividirValorEntreOperadores"
                                  :disable="selectedOperadores.length === 0 || newMeta.valor === 0"
                                  title="Dividir igualmente entre os operadores" />
                              </template>
                            </q-input>
                          </div>

                          <div v-if="newMeta.tipo === 'valor'" class="row items-center justify-end q-mt-md q-pr-md">
                            <div class="q-mr-sm text-bold">Total:</div>
                            <q-field v-model="newMeta.valor" dense class="text-right" style="width: 150px">
                              <template v-slot:control="{ id, modelValue, emitValue }">
                                <money-input :id="id" class="q-field__native text-right" :value="modelValue" @input="emitValue"
                                  v-bind="moneyFormat" />
                              </template>
                              <template v-slot:append>
                                <q-btn flat round icon="call_split" @click="dividirValorEntreOperadores"
                                  :disable="selectedOperadores.length === 0 || newMeta.valor === 0"
                                  title="Dividir igualmente entre os operadores" />
                              </template>
                            </q-field>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </q-card-section>
              <q-card-actions align="right">
                <q-btn label="Salvar" color="positive" @click="save" :loading="saving" />
              </q-card-actions>
            </q-card>
          </q-dialog>
        </q-card-section>
      </q-card>
    </div>
  </q-page>
</template>

<script>
import { createMetaMixin } from "quasar";
import { opcoesProdutosSeguras } from '@/utils/opcoes-produtos';
import axios from "@/axios-auth";
import MoneyInput from "@/components/Utils/money-input.vue";
import RadialBarChart from "../components/Graficos/radial-bar-chart.vue";
import MixedChart from "../components/Graficos/mixed-chart.vue";

export default {
  components: {
    MoneyInput,
    RadialBarChart,
    MixedChart
  },
  mixins: [createMetaMixin({ title: "DSB | Metas" })],
  data() {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const format = (d) =>
      `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;

    return {
      semPermissao: false,
      metas: [],
      operadores: [],
      selectedOperadores: [],
      produtosQtServicosFilter: null,
      produtosList: null,
      tagsQtServicosFilter: null,
      produtosTagsList: null,
      loading: false,
      saving: false,
      openDialogMeta: false,
      isNewMeta: true,
      statusFilter: "Ativos",
      dtini: format(firstDay),
      dtfim: format(lastDay),
      newMeta: {
        titulo: "",
        status: "Ativo",
        tipo: null,
        valor: 0,
        data_inicio: "",
        data_fim: "",
        operadores_metas: []
      },
      tipoOptions: [
        { label: "Valor", value: "valor" },
        { label: "Quantidade", value: "quantidade" }
      ],
      moneyFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      errors: {}
    };
  },
  watch: {
    selectedOperadores: {
      handler(val) {
        const total = val.reduce((sum, operador) => {
          return sum + (Number(operador.valor) || 0);
        }, 0);
        this.newMeta.valor = total;
      },
      deep: true
    }
  },
  methods: {
    dividirValorEntreOperadores() {
      const total = this.newMeta.valor;
      const count = this.selectedOperadores.length;

      if (count === 0) return;

      const valorPorOperador = total / count;

      this.selectedOperadores.forEach(operador => {
        operador.valor = valorPorOperador;
      });
    },
    isTodayOrFuture(date) {
      const today = new Date();
      const selected = new Date(date);

      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);

      return selected >= today;
    },
    toggleStatus() {
      this.statusFilter = this.statusFilter === 'Ativos' ? 'Inativos' : 'Ativos';
      
      this.listarMetas();
    },
    enviaData1(value) {
      this.dtini = value;
      this.listarMetas();
      this.$refs.qDateProxy.hide();
    },
    enviaData2(value) {
      this.dtfim = value;
      this.listarMetas();
      this.$refs.qDateProxy2.hide();
    }, atualizarProdutosOptions() {
      this.produtosOptions = this.produtos.filter(
        p => p.categoria === this.selectedCategoriaProduto
      );
    },
    changeFilterPeriodo(direction) {
      const formatDate = (d) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;

      let dtiniDate = new Date(this.dtini.split('/').reverse().join('-'));
      let dtfimDate = new Date(this.dtfim.split('/').reverse().join('-'));

      if (direction === 'prev') {
        dtiniDate.setDate(1);
        dtfimDate.setDate(0);
      } else if (direction === 'next') {
        dtiniDate = new Date(dtfimDate.getFullYear(), dtfimDate.getMonth() + 1, 1);
        dtfimDate = new Date(dtfimDate.getFullYear(), dtfimDate.getMonth() + 2, 0);
      }

      this.dtini = formatDate(dtiniDate);
      this.dtfim = formatDate(dtfimDate);

      this.listarMetas();
    },
    listarMetas() {
      this.loading = true;

      const params = {};
      if (this.statusFilter) {
        params.status = this.statusFilter;
      }
      if (this.dtini) {
        params.dtini = this.dtini;
      }
      if (this.dtfim) {
        params.dtfim = this.dtfim;
      }

      axios
        .get("/metas", { params })
        .then(res => {
          const metasData = Object.values(res.data.data);

          this.metas = metasData.map(meta => ({
            ...meta,
            showOperadores: false
          }));
          this.operadores = res.data.operadores.map(operador => ({
            ...operador,
            valor: 0
          }));
          this.servicosList = res.data.servicosList;
          this.produtosTagsList = res.data.produtosTagsList;
          this.produtosList = opcoesProdutosSeguras(res.data.produtosList);
        })
        .catch(err => {
          this.semPermissao = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatarValorMetaOperador(valor, tipo) {
      if (tipo === 'quantidade') {
        return Number(valor).toFixed(0);
      }
      return Number(valor).toFixed(2).replace('.', ',');
    },
    editMeta(meta) {
      this.isNewMeta = false;
      this.newMeta = {
        id: meta.id,
        titulo: meta.titulo,
        status: meta.status,
        tipo: meta.tipo,
        data_inicio: meta.data_inicio,
        data_fim: meta.data_fim,
        operadores_metas: meta.operadores_metas || []
      };

      this.selectedOperadores = [];
      if (meta.operadores_metas) {
        meta.operadores_metas.forEach(operador_meta => {
          const operador = this.operadores.find(op => op.id === operador_meta.operador_id);
          if (operador) {
            this.selectedOperadores.push({
              id: operador.id,
              valor: operador_meta.valor,
              nome: operador.nome
            });
          }
        });
      }

      if (meta.filtros) {
        this.tagsQtServicosFilter = meta.filtros.tagsQtServicosFilter;
        this.produtosQtServicosFilter = meta.filtros.produtosQtServicosFilter;
      }

      this.openDialogMeta = true;
    },
    save() {
      this.saving = true;

      const url = this.isNewMeta ? "/metas/add" : `/metas/edit/${this.newMeta.id}`;

      this.newMeta.operadores_metas = this.selectedOperadores.map(op => ({
        operador_id: op.id,
        valor: op.valor
      }));

      this.newMeta.filtros = {
        'tagsQtServicosFilter': this.tagsQtServicosFilter,
        'produtosQtServicosFilter': this.produtosQtServicosFilter,
      };

      axios.post(url, this.newMeta)
        .then(res => {
          if (!res.data.success) {
            this.$q.notify({
              color: "negative",
              message: "Erro ao salvar meta. Por favor, tente novamente.",
              position: "top-right"
            });

            this.errors = res.data.errors;

            return;
          }

          this.$q.notify({
            color: "positive",
            message: this.isNewMeta ? "Meta criada com sucesso!" : "Meta atualizada com sucesso!",
            position: "top-right"
          });

          this.resetForm();
          this.closeModal();
          this.listarMetas();
        })
        .catch(() => {
          this.$q.notify({
            color: "negative",
            message: "Erro ao salvar meta. Por favor, tente novamente.",
            position: "top-right"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    deleteMeta(meta) {
      this.$q.dialog({
        title: "Confirmar exclusão",
        message: `Deseja excluir a meta "${meta.titulo}"?`,
        cancel: true,
        persistent: true
      }).onOk(() => {
        axios.post(`/metas/delete/${meta.id}`)
          .then((res) => {
            if (!res.data.success) {
              this.$q.notify({
                color: "negative",
                message: "Erro ao excluir meta. Por favor, tente novamente.",
                position: "top-right"
              });
              return;
            }

            this.$q.notify({
              color: "positive",
              message: "Meta excluida com sucesso!",
              position: "top-right"
            });
            this.listarMetas();
          })
          .catch(() => {
            this.$q.notify({
              color: "negative",
              message: "Erro ao excluir meta. Por favor, tente novamente.",
              position: "top-right"
            });
          });
      });
    },
    duplicateMeta(meta) {
      this.$q.dialog({
        title: "Confirmar duplicação",
        message: `Deseja duplicar a meta "${meta.titulo}"?`,
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.loading = true;

        axios
          .post(`/metas/edit/${meta.id}?clonar=1`, {})
          .then((res) => {
            if (!res.data.success) {
              this.$q.notify({
                color: "negative",
                message: "Erro ao duplicar meta. Por favor, tente novamente.",
                position: "top-right"
              });
              return;
            }

            this.$q.notify({
              color: "positive",
              message: "Meta duplicada com sucesso!",
              position: "top-right"
            });

            this.listarMetas();
          })
          .catch(() => {
            this.$q.notify({
              color: "negative",
              message: "Erro ao duplicar meta. Por favor, tente novamente.",
              position: "top-right"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    closeModal() {
      this.resetForm();
      this.openDialogMeta = false;
    },
    resetForm() {
      this.newMeta = {
        titulo: "",
        status: "Ativo",
        tipo: null,
        data_inicio: "",
        data_fim: "",
        operadores_metas: [],
      };
      this.selectedOperadores = [];
      this.isNewMeta = true;
      this.errors = {};
    },
    pulaProx(value) {
      switch (value) {
        case "data_inicio":
          this.$refs.qDateInicio.hide();
          this.$refs.qDateFim.show();
          break;
        case "data_fim":
          this.$refs.qDateFim.hide();
          break;
      }
    },
    getChartSeries(meta) {
      return [meta.geral.percentual_alcancado];
    },
    getOperadoresSeries(meta) {
      if (!meta.por_operador) {
        return [];
      }

      const operadores = Object.values(meta.por_operador);
      if (!operadores.length) {
        return [];
      }

      const seriesRealizado = [];
      const seriesMeta = [];

      operadores.forEach(op => {
        const nome = op.nome || `Operador ${op.id}`;
        const totalRealizado = parseFloat(op.total_realizado || 0);
        const metaIndividual = parseFloat(op.meta_individual || 0);

        seriesRealizado.push({
          x: nome,
          y: totalRealizado,
        });

        seriesMeta.push({
          x: nome,
          y: metaIndividual,
        });
      });

      return [
        {
          name: 'Realizado',
          type: 'column',
          data: seriesRealizado,
        },
        {
          name: 'Meta',
          type: 'line',
          data: seriesMeta,
        },
      ];
    },
    getOperadoresChartOptions(meta) {
      if (!meta.por_operador) return {};

      const operadores = Object.values(meta.por_operador);
      if (!operadores.length) return {};

      const formatValue = (value) => {
        if (meta.tipo === 'valor') {
          return `R$ ${parseFloat(value).toFixed(2).replace('.', ',')}`;
        }
        return parseInt(value, 10);
      };

      return {
        chart: {
          type: 'line',
          stacked: false,
          toolbar: { show: false }
        },
        plotOptions: {
          bar: {
            distributed: false,
          }
        },
        colors: [
          "#43A047", // Realizado (operadores)
          "#E53935"  // Meta
        ],
        tooltip: {
          y: {
            formatter: (value) => formatValue(value)
          }
        },
        dataLabels: {
          formatter: (value) => formatValue(value)
        }
      };
    },

    getChartOptions(meta) {
      let color;
      const percentage = meta ? meta.geral.percentual_alcancado : 0;

      if (percentage < 30) {
        color = "#E53935"; // Vermelho
      } else if (percentage < 70) {
        color = "#FB8C00"; // Amarelo
      } else {
        color = "#43A047"; // Verde
      }

      return {
        chart: {
          stacked: false,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: 0,
                fontSize: '22px'
              },
            }
          }
        },
        colors: [color]
      };
    },
    adicionarTodosOperadores() {
      this.operadores.forEach(operador => {
        if (!this.selectedOperadores.some(op => op.id === operador.id)) {
          this.selectedOperadores.push(operador);
          this.newMeta.operadores_metas.push({ operador_id: operador.id, meta: 0 });
        }
      });
    }
  },
  mounted() {
    this.listarMetas();
  }
};
</script>

<style lang="stylus" scoped>
  .q-table

    thead th
      font-weight: bold

    .small-column
      width: 100px;
</style>
